import { Alert }               from '@/components/ui/alert'
import { DialogRoot }          from '@/components/ui/dialog'
import { DialogContent }       from '@/components/ui/dialog'
import { DialogHeader }        from '@/components/ui/dialog'
import { DialogTitle }         from '@/components/ui/dialog'
import { DialogBody }          from '@/components/ui/dialog'
import { DialogCloseTrigger }  from '@/components/ui/dialog'
import PasswordForm            from '@/pages/Security/forms/PasswordForm'
import { Dispatch }            from 'react'
import { SetStateAction }      from 'react'
import { useTranslation }      from 'react-i18next'

interface IPasswordModalProps {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
	onChangePasswordSuccess: () => void;
}

const PasswordModal = (props: IPasswordModalProps) => {
	const { isOpen, setIsOpen, onChangePasswordSuccess } = props;
	const { t } = useTranslation();
	return (
		<DialogRoot open={isOpen} size={{ base: "xs", lg: "lg" }}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{t('pages.security.passwordBox.actions.edit')}</DialogTitle>
				</DialogHeader>
				<DialogBody pb="4">
					<Alert status="info" title={t('pages.security.passwordBox.modals.forms.alert')} />
					<PasswordForm onChangePasswordSuccess={onChangePasswordSuccess} setIsOpen={setIsOpen} />
				</DialogBody>
				<DialogCloseTrigger onClick={() => setIsOpen(false)} />
			</DialogContent>
		</DialogRoot>
	)
}

export default PasswordModal